// backgroundColor -> background-color
export const toKebabCase = str => str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

// { backgroundColor: 'red', color: 'blue' } -> 'background-color:red;color:blue'
export const cssString = style => !style ? null : Object.entries(style).map(([key, value]) => `${toKebabCase(key)}:${value}`).join(';');

// To be able to add styles from overrides, no matter if base styles are strings or objects or undefined
//   base.attributes.style = mergeStyles(base.attributes.style, { backgroundColor: red });
export const mergeStyles = (...parts) => (
	parts.filter(e => typeof e === 'string')
		.concat(cssString(Object.assign({}, ...parts.filter(e => e && typeof e === 'object'))))
		.join(';')
);